/* ---------------------------------------------------------------------------
   DreamPrices – "Lägg i varukorgen".  Stabiliserad 2026-08-08.

   Ändringar mot temats original:
   - Lådan öppnas DIREKT med laddningsläge i stället för efter serverns svar
     (~0,5–1,5 s utan någon återkoppling = upplevdes som segt).
   - Spärr mot dubbelklick: ett nytt klick medan anropet pågår ignoreras i
     stället för att lägga varan två gånger.
   - <cart-notification> slås upp vid klick, inte i constructor – annars kunde
     referensen bli null (t.ex. i snabbvyn) och lådan aldrig öppnas trots att
     varan LÅG i varukorgen.
   - Fel hanteras: knappen låses aldrig fast och lådan blir inte hängande i
     laddningsläge.
   --------------------------------------------------------------------------- */

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.form) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }

        this.hideErrors = this.dataset.hideErrors === "true";
        this.busy = false;
      }

      get cartNotification() {
        return document.querySelector("cart-notification");
      }

      get cartItems() {
        return document.querySelector("cart-items");
      }

      get sectionIds() {
        return (
          window.DP_CART_SECTIONS || [
            "cart-notification-product",
            "cart-notification-subtotal",
            "cart-notification-count",
            "cart-notification-discount",
          ]
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.busy) return; // dubbelklick ska inte ge två rader i varukorgen
        this.busy = true;

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.setAttribute("disabled", "disabled");
          submitButton.classList.add("loading");
        }

        const cartNotification = this.cartNotification;
        const cartItems = this.cartItems;

        /* Öppna lådan omedelbart med laddningsläge – kunden ska se att något
           händer redan innan servern svarat. */
        if (cartNotification && typeof cartNotification.open === "function") {
          if (typeof cartNotification.setActiveElement === "function") {
            cartNotification.setActiveElement(document.activeElement);
          }
          cartNotification.open(true);
        }

        const config =
          typeof fetchConfig === "function"
            ? fetchConfig("javascript")
            : { method: "POST", headers: {} };
        config.headers = config.headers || {};
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append("sections", this.sectionIds.join(","));
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState && parsedState.status) {
              // t.ex. slutsåld variant – stäng lådan och visa felet vid knappen
              if (cartNotification && typeof cartNotification.close === "function") {
                cartNotification.close();
              }
              this.handleErrorMessage(parsedState.description);
              return;
            }

            document
              .querySelector(".product-form__error-message-wrapper")
              ?.classList.add("no-js-inline");

            if (cartNotification && typeof cartNotification.renderContents === "function") {
              cartNotification.renderContents(parsedState);
            }
            if (cartItems && typeof cartItems.renderContents === "function") {
              cartItems.renderContents(parsedState);
            }
          })
          .catch((e) => {
            console.error("[DreamPrices] lägg i varukorgen:", e);
            if (cartNotification && typeof cartNotification.close === "function") {
              cartNotification.close();
            }
          })
          .finally(() => {
            this.busy = false;
            if (submitButton) {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");
            }
            if (cartNotification && typeof cartNotification.setLoading === "function") {
              cartNotification.setLoading(false);
            }
            document.getElementById("quickViewWrapper")?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}
